import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-rx-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="rx-confirm-message">{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(false)">CANCEL</button>
      <button mat-raised-button color="warn" type="button" (click)="dialogRef.close(true)">
        {{ data.confirm || 'CONFIRM' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .rx-confirm-message {
        margin: 0;
        font-size: 13px;
        line-height: 1.4;
      }
    `,
  ],
})
export class RxConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RxConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; message: string; confirm?: string }
  ) {}
}

@Component({
  selector: 'app-rx-image-viewer-dialog',
  template: `
    <h2 mat-dialog-title>RX IMAGE</h2>
    <mat-dialog-content>
      <img class="rx-viewer-image" [src]="data.image" alt="Uploaded RX">
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">CLOSE</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .rx-viewer-image {
        display: block;
        max-width: 80vw;
        max-height: 80vh;
        margin: 0 auto;
      }
    `,
  ],
})
export class RxImageViewerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RxImageViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { image: string }
  ) {}
}

